module.exports = __webpack_public_path__ + "img/s3-3.24833a84.jpg";